import { Navigate } from "react-router-dom";

const getToken = () => localStorage.getItem("authToken");
const getUserRole = () => localStorage.getItem("userRole");
const isAuthenticated = (requiredRole) =>
  !!getToken() && (getUserRole() === requiredRole || requiredRole === "all");
// eslint-disable-next-line react/prop-types
const ProtectedRoute = ({ children, requiredRole }) => {
  return isAuthenticated(requiredRole) ? children : <Navigate to="/sign-in" replace />;
};

export default ProtectedRoute;
